import { IonChip, IonGrid, IonIcon, IonLabel, IonRow, IonToolbar } from '@ionic/react'
import { closeCircleOutline } from 'ionicons/icons'
import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { IRootState } from '../../../store'
import { TimelineConstants } from '../store/timeline.constants'

import './filter.component.css'

const FilterComponent: React.FC = (): JSX.Element => {
  const dispatch = useDispatch()

  const timeline = useSelector((state: IRootState) => state.timeline)
  const { filterChips, showClearFiltersButton } = timeline

  return (
    <IonToolbar color='light'>
      <IonGrid class='ion-no-padding ion-margin-top'>
        <IonRow class='ion-nowrap no-flex-shrink scroll-display'>
          {showClearFiltersButton && (
            <IonIcon
              qa-id='clear_filters_icon'
              class='ion-align-self-center'
              size='large'
              icon={closeCircleOutline}
              color='medium'
              onClick={() => {
                dispatch({ type: TimelineConstants.CLEAR_FILTERS })
              }}
            />
          )}
          {filterChips.map((filterChip) => (
            <IonChip
              key={filterChip.itemType}
              outline={!filterChip.isSelected}
              onClick={() => dispatch({ type: filterChip.filterAction })}>
              <IonLabel>{filterChip.itemType}</IonLabel>
            </IonChip>
          ))}
        </IonRow>
      </IonGrid>
    </IonToolbar>
  )
}

export default FilterComponent
